"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributeValues = void 0;
const react_1 = require("react");
const measures_1 = require("../../../../../client/measures");
const values_1 = require("../../../../../client/values");
const store_1 = require("../../../../../../store");
const useAttributeValues = ({ attributeName, sortingItem, isMeasure, valueSearch, options, }) => {
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const selectedStrategyNodeId = (0, store_1.useSelectedTreeNodeId)();
    const { data: textAttributeValues, isLoading: textAttributeValuesLoading, isRefetching: textAttributeValuesRefetching, error: textAttributeValuesLoadingError, attributeProductCount, isAttributeModified, pagination: { isLoadingMore: moreTextAttributeValuesLoading, hasNextPage: textAttributeValuesHasNextPage, onNextPage: fetchMoreTextAttributeValues, }, } = (0, values_1.useGetTextAttributeAggregatedValues)({
        includeNA: true,
        catalogId: selectedCatalogId,
        productTreeNodeId: selectedStrategyNodeId,
        attributeName,
        sortingItem,
        valueSearch,
        options: { skip: isMeasure || options.skip },
    });
    const { data: measureUnits, isLoading: measureUnitsLoading, isRefetching: measureUnitsRefetching, error: measureUnitsLoadingError, pagination: { hasNextPage: measureUnitsHasNextPage, onNextPage: fetchMoreMeasureUnits, isLoadingMore: moreMeasureUnitsLoading, }, } = (0, measures_1.useGetAggregatedProductMeasureUnits)({
        catalogId: selectedCatalogId,
        productTreeNodeId: selectedStrategyNodeId,
        dimension: attributeName,
        sortingItem,
        options: { skip: !isMeasure || options.skip },
    });
    const values = (0, react_1.useMemo)(() => {
        var _a;
        if (!isMeasure) {
            return textAttributeValues !== null && textAttributeValues !== void 0 ? textAttributeValues : [];
        }
        const measureValues = (_a = measureUnits === null || measureUnits === void 0 ? void 0 : measureUnits.map(({ node: { productCount, unit, values } }) => {
            var _a;
            return ({
                productCount,
                value: unit,
                isMeasureUnit: true,
                nestedValues: (_a = values.edges) === null || _a === void 0 ? void 0 : _a.map(({ node: { value, productCount } }) => ({ value, productCount })),
            });
        })) !== null && _a !== void 0 ? _a : [];
        return measureValues;
    }, [isMeasure, measureUnits, textAttributeValues]);
    return {
        data: values,
        isLoading: textAttributeValuesLoading || measureUnitsLoading,
        isRefetching: textAttributeValuesRefetching || measureUnitsRefetching,
        error: textAttributeValuesLoadingError || measureUnitsLoadingError,
        attributeProductCount,
        isAttributeModified,
        pagination: {
            isLoadingMore: moreTextAttributeValuesLoading || moreMeasureUnitsLoading,
            onNextPage: !isMeasure ? fetchMoreTextAttributeValues : fetchMoreMeasureUnits,
            hasNextPage: textAttributeValuesHasNextPage || measureUnitsHasNextPage,
        },
    };
};
exports.useAttributeValues = useAttributeValues;
